if (!customElements.get('support-modal')) {
  class SupportModal extends HTMLElement {
    static OPEN_CLASS = 'is-open';

    constructor() {
      super();

      this.handleToggleRef = this.handleToggle.bind(this);
    }

    handleToggle(event) {
      this.classList.toggle(SupportModal.OPEN_CLASS);

      if (this.classList.contains(SupportModal.OPEN_CLASS)) {
        bodyScroll.lock(this.firstElementChild);
      } else {
        bodyScroll.clear();
      }

      if (!event.detail.title) return;

      const productInput = this.querySelector('[name="contact[product-name]"]');
      productInput.value = event.detail.title;

      const productTitle = this.querySelector('[js-product-title]');
      productTitle.innerHTML = event.detail.title;
    }

    disconnectedCallback() {
      document.removeEventListener(`${this.id}:toggle`, this.handleToggleRef);
    }

    connectedCallback() {
      document.addEventListener(`${this.id}:toggle`, this.handleToggleRef);

      this.addEventListener('submit', (event) => {
        event.stopPropagation();
        event.stopImmediatePropagation();
      });
    }
  }

  customElements.define('support-modal', SupportModal);
}
